export default function isUserAuthenticated(state) {
  return state.isAuthenticated;
}
